/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseNotificationData } from './BaseNotificationData';
import type { FromEventSourceNotification } from './FromEventSourceNotification';
import type { FromMonthlyAchievement } from './FromMonthlyAchievement';
import type { FromNormalAchievement } from './FromNormalAchievement';
export type NewBadgeAcquiredNotification = (BaseNotificationData & {
    type: NewBadgeAcquiredNotification.type;
    badgeId: number;
    source: (FromEventSourceNotification | FromNormalAchievement | FromMonthlyAchievement);
});
export namespace NewBadgeAcquiredNotification {
    export enum type {
        GOT_NEW_BADGE = 'got_new_badge',
    }
}

